import React from 'react';
import { useDocumentConfig } from '../../utils/FetchConfig';
import Fieldset from '../../components/connectedForm/Fieldset';
import Legend from '../../components/connectedForm/Legend/Legend';
import CheckboxInput from '../../components/connectedForm/CheckboxInput';
import { QuantityToPick } from '../../graphql/schema/p4types';

export const DocumentCarouselPickingInstructionConfiguration = ({
  reset,
  onResetToggle,
}): { reset: boolean; onResetToggle: (reset: boolean) => void } => {
  const documentConfig = useDocumentConfig();

  const extraConfigurationRequired =
    documentConfig?.pickingInstructionDefault?.quantityToPick === QuantityToPick.NewAllocations;

  if (!extraConfigurationRequired) {
    return null;
  }

  return (
    <Fieldset cols={1}>
      <Legend styles={{ root: { marginRight: 0 } }} label="Extra Configuration" />
      <CheckboxInput
        onChange={() => onResetToggle(!reset)}
        label="Reset balances"
        value={reset}
        data-testid={'sales-order-action-extra-configuration'}
      />
    </Fieldset>
  );
};
